import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';

// Pages
import Dashboard from './pages/Dashboard';
import ArtikelListe from './pages/artikel/ArtikelListe';
import ArtikelDetail from './pages/artikel/ArtikelDetail';
import ArtikelForm from './pages/artikel/ArtikelForm';
import ArtikelExport from './pages/artikel/ArtikelExport';
import EtikettendruckPage from './pages/etikettendruck/EtikettendruckPage';
import WarenkorbPage from './pages/warenkorb/WarenkorbPage';
import BestellungListe from './pages/bestellungen/BestellungListe';
import BestellungDetail from './pages/bestellungen/BestellungDetail';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="d-flex flex-column min-vh-100">
      <NavigationBar />
      <Container className="flex-grow-1 mb-4">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          
          {/* Artikel Routen */}
          <Route path="/artikel" element={<ArtikelListe />} />
          <Route path="/artikel/neu" element={<ArtikelForm />} />
          <Route path="/artikel/export" element={<ArtikelExport />} />
          <Route path="/artikel/:id" element={<ArtikelDetail />} />
          <Route path="/artikel/:id/bearbeiten" element={<ArtikelForm />} />
          
          {/* Kurzform für Artikel (ohne Slash) */}
          <Route path="/artikel:id" element={<ArtikelDetail />} />
          
          {/* Etikettendruck Route */}
          <Route path="/etikettendruck" element={<EtikettendruckPage />} />

          {/* Warenkorb Route */}
          <Route path="/warenkorb" element={<WarenkorbPage />} />
          
          {/* Bestellungen Routen */}
          <Route path="/bestellungen" element={<BestellungListe />} />
          <Route path="/bestellungen/:id" element={<BestellungDetail />} />
          
          {/* QR-Code Scanner wird über externe App bereitgestellt */}
          
          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Container>
      <Footer />
    </div>
  );
}

export default App;
